"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacingSelector = void 0;
var spacingSelector = function (props, level) {
    if (props.theme.variables) {
        return props.theme.variables.spacing[level];
    }
    throw new Error("Theme seems to be missing. Please ensure the NEFThemeProvider component is wrapping your application.");
};
exports.spacingSelector = spacingSelector;
var getSpacing = function (level) {
    return function (props) { return exports.spacingSelector(props, level); };
};
exports.default = getSpacing;
//# sourceMappingURL=index.js.map